module.exports = __webpack_public_path__ + "static/media/ulip.03455210.mp3";